import { css } from '@emotion/core'
import { colors, measures } from 'styles/variables'

const { unit, half } = measures

export const card = css`
  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;

  box-shadow: 0 ${half}px ${unit}px 0 ${colors.black20};
  transition: 300ms;

  text-align: center;

  :hover {
    box-shadow: 0 ${unit}px ${2 * unit}px 0 ${colors.black20};
  }

  ::before {
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 12px;

    background-color: ${colors.black60};

    opacity: 0;

    color: ${colors.white100};

    content: attr(data-label);

    position: absolute;

    padding: ${half}px;

    bottom: 0;
    right: 0;
    left: 0;
    top: 100%;

    text-align: center;

    transition: top 300ms, opacity 300ms;
  }

  :hover::before {
    top: 0;
    opacity: 1;
  }
`

export const image = css`
  object-fit: contain;
  height: inherit;
`

export const caption = css`
  padding: ${unit}px;
`

// TODO: temp solution with wrapper size
export const imageWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: ${unit}px;

  height: ${10 * unit}px;
  width: ${10 * unit}px;
`

export const selected = css`
  box-shadow: 0 ${half}px ${unit}px 0 ${colors.primaries.primary3};

  :hover {
    box-shadow: 0 ${unit}px ${2 * unit}px 0 ${colors.primaries.primary3};
  }
`
